module.exports = __webpack_public_path__ + "images/line_friend_lp/campaign-headline_744b3c21d666559582695461469efe80.png";